export const CSS = {
  container: "container",
  heading: "heading",
};
